import styled, {keyframes} from 'styled-components';

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }
  
  100% {
    background-position: 46.8rem 0; 
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
`;

export const SrpTabDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width:15.4rem;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-top-left-radius:${props.theme.misc.borderRadius.xxxlarge};
  border-top-right-radius:${props.theme.misc.borderRadius.xxxlarge};
  border-bottom-right-radius:0;
  border-bottom-left-radius:0;
  padding:${props.theme.spacing.base};
  justify-content:space-between;
  align-items:center;
  margin-right:${props.theme.spacing.custom(8)}

`,
);

export const HotelIconSpan = styled(contentLoader)(
  props => `
  width:1.8rem;
  height:1.8rem;

`,
);

export const HotelTypeSpan = styled(contentLoader)(
  props => `
  width:10.6rem;
  height:1.2rem;

`,
);
